import InternalDashboard from './InternalDashboard';

export default InternalDashboard;
